import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import Swal from "sweetalert2";

const COLORS = [
  "#22c55e", "#3b82f6", "#ef4444", "#f59e0b", "#8b5cf6", "#14b8a6", "#f43f5e"
];

const Dashboard = ({ Ip }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = new FormData();
        formData.append("Action", "getUrlsSummary");

        const res = await axios.post(
          `${Ip}/Dashboard/dashboard.php`,
          formData
        );

        console.log("Dashboard data:", res.data);

        if (res.data.success) {
          // PHP returns only age and total
          const mappedData = res.data.data.map((item) => ({
            age: item.age,
            total: item.total,
          }));

          setChartData(mappedData);
        } else {
          Swal.fire("Error", "Could not fetch data from server", "error");
        }
      } catch (err) {
        console.error("Error fetching summary:", err);
        Swal.fire("Error", "Network error while fetching summary", "error");
      }
    };

    fetchData();
  }, [Ip]);

  return (
    <div className="dashboard-container">
      <h2 className="text-center mb-4">📊 Users by Age Overview</h2>

      {/* Bar Chart */}
      <div style={{ width: "100%", height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="age"
              tick={{ fontSize: 12 }}
              interval={0}
              angle={-20}
              textAnchor="end"
              height={60}
              label={{ value: "Age", position: "insideBottom", offset: -10 }}
            />
            <YAxis
              label={{
                value: "Total Users",
                angle: -90,
                position: "insideLeft",
                offset: 10,
              }}
            />
            <Tooltip />
            <Legend />
            <Bar dataKey="total" fill="#3b82f6" name="Total Users" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Pie Chart */}
      <div style={{ width: "100%", height: 400, marginTop: 40 }}>
        <h3 className="text-center mb-3">🥧 Users Distribution by Age</h3>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              dataKey="total"
              nameKey="age"
              cx="50%"
              cy="50%"
              outerRadius={150}
              innerRadius={60}
              paddingAngle={4}
              label={({ name, value }) => `${name}: ${value}`}
              isAnimationActive={true}
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Dashboard;
